import React, { Component, useState, useEffect } from 'react';
import { Show, List, TabbedShowLayout, Tab, Datagrid, BooleanField, EditButton, TextField, ReferenceField, ReferenceManyField, DateField, TopToolbar, RefreshButton, ListButton, useRecordContext, usePermissions, useResourceContext, useTranslate } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from '../digitalOrders/common';
import { Scrollbars } from 'react-custom-scrollbars';
import { getLocalStorageKey, CommonHeaderOption, RUN_TIME_API_ENDPOINT } from '../common/common';
import { useLocation } from 'react-router-dom';
// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ShowActions = () => {
    const resource = useResourceContext();
    return (
        <TopToolbar>
            <RefreshButton />
            <ListButton basePath={resource} />
        </TopToolbar>
    )
}

const ShowTitle = () => {
    const record = useRecordContext();
    return record && <span>Send Message&nbsp;</span>;
};

const SendMessageShow = (props) => {

    const [loadingShow, setLoadingShow] = useState(false);

    const permissions = usePermissions();
    const translate = useTranslate();
    const location = useLocation();
    const pathSplit = location.pathname.split('/');
    const smsMessageId = pathSplit[2]
    
    return (
        <Show actions={<ShowActions permissions={permissions} />} title={<ShowTitle />}>
            <TabbedShowLayout className="tab-scroll">
                <Tab label={translate('resources.in_app_notifications.fields.details')} contentClassName="scrollTab">
                    <TextField source="purpose" allowEmpty />
                    <TextField source="text" allowEmpty />
                    <TextField source="target_type" allowEmpty />
                    <TextField source="sms_length" sortable={false} allowEmpty />
                    <TextField source="targeted_businesses_count" />
                    <TextField source="number_of_messages" />
                    <TextField source="notified_businesses_count" />
                    <TextField source="failed_businesses" allowEmpty />
                    {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                    <DateField source="created_at" showTime />
                </Tab>
                <Tab label={translate('resources.in_app_notifications.fields.sold_list')}>
                    <ReferenceManyField
                        label=""
                        reference="sms_blast_sold_to_list"
                        target="id"
                        className="tab-pagination"
                    >
                        <List
                            filterDefaultValues={{ id: smsMessageId }} 
                            hasCreate={false}
                            exporter={false}
                            actions={false}
                            >
                            <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                                <TextField source="id" />
                                <TextField source="name" />
                                <TextField source="phone" />
                                <BooleanField source="send_status" />
                                <TextField source="send_response" />
                            </Datagrid>
                        </List>
                    </ReferenceManyField>
                </Tab>
            </TabbedShowLayout>
        </Show>
    );
}

export default SendMessageShow;